<template>
  <div class="mt-4 grid gap-8 md:grid-cols-12">
    <MutableTransferAddress :transfer="transfer" mode="pickup" :is-mutable="isDelivery" />

    <div class="self-center max-sm:w-6 max-sm:justify-self-center md:col-span-2 md:max-w-10">
      <HorizontalArrow right class="max-sm:rotate-90" />
    </div>

    <MutableTransferAddress :transfer="transfer" mode="dropoff" :is-mutable="!isDelivery" />
  </div>
</template>

<script lang="ts" setup>
import HorizontalArrow from '@/components/HorizontalArrow.vue';
import type { Allocation } from '@/entities/allocations/allocation.entity';
import { AllocationType } from '@carvia/ros-client-types';
import { computed } from 'vue';
import MutableTransferAddress from './MutableTransferAddress.vue';

const props = defineProps<{
  transfer: Allocation;
}>();

const isDelivery = computed(() => props.transfer.type === AllocationType.TRANSFER_DELIVERY);
</script>

<i18n lang="json">
{
  "en": {
    "street": "Street",
    "station": "Station"
  },
  "de": {
    "street": "Straße",
    "station": "Station"
  },
  "es": {
    "street": "Calle",
    "station": "Estación"
  }
}
</i18n>
